import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {Router, RouterModule} from '@angular/router';

import { WheelHeadingComponent } from './components/wheel-heading/wheel-heading.component';
import { ImagePathPipe } from './pipes/image-path.pipe';
import {ApiServices} from './services/api.service';
import {FormService} from './services/form.service';
import { CategoryModalComponent } from './modals/category-modal/category-modal.component';
import {NgbAlertModule} from '@ng-bootstrap/ng-bootstrap';
import { LoaderComponent } from './components/loader/loader.component';
import { MultipleOfPipe } from './pipes/multiple-of.pipe';
import { PreloaderComponent } from './components/preloader/preloader.component';
import { NotFoundComponent } from './components/not-found/not-found.component';

// import { FitmentSearchFormComponent } from './components/fitment-search-form/fitment-search-form.component';

import { WheelSizeDropdownComponent } from './components/wheel-size-dropdown/wheel-size-dropdown.component';
import { FirstWordPipe } from './pipes/first-word.pipe';
import { BaseImagePipe } from './pipes/base-image.pipe';
import {LoginFormComponent} from './components/login/login-form.component';
import {FacebookLoginProvider, GoogleLoginProvider, SocialAuthServiceConfig, SocialLoginModule} from 'angularx-social-login';
import { OrderStatusPipe } from './pipes/order-status.pipe';
import {MetaService} from './services/meta.service';
import { SearchByVehicleComponent } from './components/search-by-vehicle/search-by-vehicle.component';
import { SearchBySizeComponent } from './components/search-by-size/search-by-size.component';

// Import new wheel modal components
import { WheelProductInfoComponent } from './components/wheel-product-info/wheel-product-info.component';
import { WheelFitmentDisplayComponent } from './components/wheel-fitment-display/wheel-fitment-display.component';
import { WheelSearchBySizeSelectorComponent } from './components/wheel-search-by-size-selector/wheel-search-by-size-selector.component';
import { WheelCartManagerComponent } from './components/wheel-cart-manager/wheel-cart-manager.component';
import { WheelSizeSelectionManagerComponent } from './components/wheel-size-selection-manager/wheel-size-selection-manager.component';
import { WheelRegularSizeSelectorComponent } from './components/wheel-regular-size-selector/wheel-regular-size-selector.component';
import { WheelProductCustomizationComponent } from './components/wheel-product-customization/wheel-product-customization.component';

// Import new services
import { WheelCartService } from './services/wheel-cart.service';
import { WheelPricingService } from './services/wheel-pricing.service';
import { WheelRouteDetectionService } from './services/wheel-route-detection.service';


@NgModule({  declarations: [
    WheelHeadingComponent,
    ImagePathPipe,
    CategoryModalComponent,
    LoaderComponent,
    MultipleOfPipe,
    PreloaderComponent,
    NotFoundComponent,
    // FitmentSearchFormComponent,
    WheelSizeDropdownComponent,
    FirstWordPipe,
    BaseImagePipe,
    LoginFormComponent,
    OrderStatusPipe,
    SearchByVehicleComponent,
    SearchBySizeComponent,    // New wheel modal components
    WheelProductInfoComponent,
    WheelFitmentDisplayComponent,
    WheelSearchBySizeSelectorComponent,
    WheelCartManagerComponent,
    WheelSizeSelectionManagerComponent,
    WheelRegularSizeSelectorComponent,
    WheelProductCustomizationComponent
  ],
  imports: [
    CommonModule,
    NgbAlertModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    // SocialLoginModule
  ],  exports: [
    WheelHeadingComponent,
    ImagePathPipe,
    CategoryModalComponent,
    LoaderComponent,
    MultipleOfPipe,
    PreloaderComponent,
    NotFoundComponent,
    // FitmentSearchFormComponent,
    WheelSizeDropdownComponent,
    FirstWordPipe,
    BaseImagePipe,
    LoginFormComponent,
    OrderStatusPipe,
    SearchByVehicleComponent,
    SearchBySizeComponent,    // Export new wheel modal components
    WheelProductInfoComponent,
    WheelFitmentDisplayComponent,
    WheelSearchBySizeSelectorComponent,
    WheelCartManagerComponent,
    WheelSizeSelectionManagerComponent,
    WheelRegularSizeSelectorComponent,
    WheelProductCustomizationComponent
  ],  providers: [
    ApiServices,
    MetaService,
    FormService,
    // New wheel services
    WheelCartService,
    WheelPricingService,
    WheelRouteDetectionService,
    {
      provide: 'SocialAuthServiceConfig',
      useValue: {
        autoLogin: false,
        providers: [
          {
            id: GoogleLoginProvider.PROVIDER_ID,
            provider: new GoogleLoginProvider(
              '902787108713-mu48d6bddk7i407k6jbp8ilbso6tj93s.apps.googleusercontent.com',
            ),
          },
          {
            id: FacebookLoginProvider.PROVIDER_ID,
            provider: new FacebookLoginProvider("542875379535360"),
          },
        ],
      } as SocialAuthServiceConfig,
    }
  ]
})
export class SharedModule { }
